import { Link } from 'react-router-dom';
import { Container } from '@/components/layout/Container';

export function NotFoundPage() {
  return (
    <Container className="py-24 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-brand-700">404</p>
      <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900">
        We could not find that page
      </h1>
      <p className="mx-auto mt-2 max-w-md text-slate-600">
        The link may be out of date, or the ride may no longer be listed.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex h-11 items-center rounded-xl bg-brand-700 px-5 text-sm font-medium text-white hover:bg-brand-800"
      >
        Back to search
      </Link>
    </Container>
  );
}
